module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/ian_pointing_down-026a77087cf65bf8bbd037d9b72502c3.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/ian_pointing_down.png
// module id = 2373
// module chunks = 2